import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateMoreOptionLogQuantityQuestions } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';
import { t } from 'services/i18n.service';
import { v4 as uuid } from 'uuid';
import LogQuantityQuestionsEditor from './LogQuantityQuestionsEditor';

const LogQuestions: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);
  const logQuestions = activity?.log_quantity_questions ?? [];

  return (
    <LogQuantityQuestionsEditor
      questions={logQuestions}
      onQuestionsChange={(questions) =>
        dispatch(updateMoreOptionLogQuantityQuestions(questions))
      }
      onCreateQuestionId={() => uuid()}
      emptyMessage={t('tabs_revamp.log_data_tab.no_questions_added')}
      compact
    />
  );
};

export default LogQuestions;
